























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ToolItemNav extends Vue {
  @Prop() private id!: string;
  @Prop() private title!: string;
  @Prop() private icon!: string;
  @Prop() private isAlert!: boolean; // 是否是提醒按钮

  alertStyle() {
    if (this.isAlert) {
      return 'background-color:#409EFF';
    }
    return '';
  }
}
